import Vue from "vue";

export default {
    namespaced: true,
    state: {
        messagerie: {
            infos: {
                nb_page: 1
            }
        },
        count: 0,
        not_view: false,
        type: 0,
        mail: {}
    },
    actions: {
        fetch: ({ commit, state, rootState }, current_page = 1) => {
            if(rootState.user.user == null) return
            let not_view = state.not_view;
            return Vue.http.post('index.php?action=api.fetch', { data: JSON.stringify({
                    "infos": {
                        "token": rootState.user.user.token,
                        "name": "get_mail",
                        "current_page": current_page,
                        "only_not_view": not_view,
                        "order_key": "mail_spool_id",
                        "order": "DESC",
                        "type": state.type
                    }
                })}, { emulateJSON: true })
                .then(response => {
                    commit('GET_MESSAGERIE', response.data);
                })
                .catch(error => {
                    console.log(error)
                })
        },
        view: ({ commit, rootState, dispatch }, data) => {
            return Vue.http.post('index.php?action=api.fetch', { data: JSON.stringify({
                    "infos": {
                        "token": rootState.user.user.token,
                        "name": "set_mail_view",
                        "message_id": data.message_id
                    }
                })}, { emulateJSON: true })
                .then(response => {
                    commit('VIEW_MESSAGERIE', data)
                    dispatch('count')
                })
        },
        show: ({ commit, dispatch, state }, id) => {
            dispatch('view', { id : id, message_id : state.messagerie.data[id].mail_spool_user_id })
            return commit('SHOW_MESSAGERIE', id)
        },
        archive: ({ commit, state, rootState, dispatch }, id) => {
            return Vue.http.post('index.php?action=api.fetch', { data: JSON.stringify({
                    "infos": {
                        "token": rootState.user.user.token,
                        "name": "set_mail_archive",
                        "message_id": state.messagerie.data[id].mail_spool_user_id
                    }
                })}, { emulateJSON: true })
                .then(response => {
                    dispatch('fetch')
                })
        },
        delete: ({ commit, rootState, dispatch, state }, id = null) => {
            return Vue.http.post('index.php?action=api.fetch', { data: JSON.stringify({
                    "infos": {
                        "token": rootState.user.user.token,
                        "name": "delete_mail",
                        "message_id": (id === null) ? null : state.messagerie.data[id].mail_spool_user_id
                    }
                })}, { emulateJSON: true })
                .then(response => {
                    dispatch('fetch')
                })
        },
        count: ({ commit, rootState }) => {
            if(rootState.user.user == null) return
            return Vue.http.post('index.php?action=api.fetch', { data: JSON.stringify({
                    "infos": {
                        "token": rootState.user.user.token,
                        "name": "get_mail_notview"
                    }
                })}, { emulateJSON: true })
                .then(response => commit('COUNT_MESSAGERIE', response.data.data))
                .catch(error => console.log(error))
        },
        notView: ({ commit, dispatch }) => {
            commit('CHANGE_VIEW_MESSAGERIE')
            return dispatch('fetch')
        },
        type: ({ commit, dispatch }, type_id) => {
            commit('TYPE_MESSAGERIE', type_id)
            return dispatch('fetch')
        }
    },
    mutations:{
        GET_MESSAGERIE: (state, data) => {
            state.messagerie = data.data
        },
        VIEW_MESSAGERIE: (state, data) => {
            if(!state.messagerie.data[data.id]) return;
            state.messagerie.data[data.id].view = 1
        },
        SHOW_MESSAGERIE: (state, id) => {
            state.mail = state.messagerie.data[id]
        },
        COUNT_MESSAGERIE: (state, data) => {
            if(data.code === 'NOK') return
            state.count = data
        },
        CHANGE_VIEW_MESSAGERIE: (state) => {
            if(state.not_view) return state.not_view = false
            else return state.not_view = true
        },
        TYPE_MESSAGERIE: (state, type_id) => {
            if(type_id === state.type) return state.type = 0
            else return state.type = type_id
        }
    },
    getters: {
        data: state => state.messagerie.data,
        infos: state => state.messagerie.infos,
        count: state => state.count,
        show: state => state.mail,
        notView: state => state.not_view,
        type: state => state.type
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/messagerie.js